import { getActiveParams } from '../../business/views/DataManager';
import Apis from '@model';

export const trackActiveEvent = (eventName, trackMethod, formdata = {}) => {
  const { baseParam, sn, pcsn: pcsnParam } = getActiveParams();
  // eslint-disable-next-line standard/object-curly-even-spacing
  const { opsBrand, masterVersion, osName, masterModel} = baseParam;
  let {company, dealer, districtArr, street} = formdata;
  districtArr = districtArr || [];
  Apis.getActiveInfo(sn).then(res => {
    const { message, data } = res;
    if (message === 'success' && data.length) {
      const {
        uProvince,
        uCity,
        uTown,
        uStreet,
        uSchool,
        rSalesModel,
        time,
        pcsn
      } = data[0];
      trackMethod(
        eventName,
        {
          device_id: sn,
          device_model: masterModel,
          custom_device_model: masterModel && masterModel.split('-')[0],
          dsu_version: masterVersion,
          device_brand: opsBrand,
          original_os: osName,
          pc_sn: pcsnParam || pcsn,
          // 这两个暂时没有
          custom_os_version: '',
          mau_version: '',
          active_time: time,
          province: districtArr[0] || uProvince,
          city: districtArr[1] || uCity,
          county: districtArr[2] || uTown,
          address: street || uStreet,
          company: company || uSchool,
          sales_model: rSalesModel,
          // 用当前的时间
          scan_time: Date.now(),
          dealer: dealer || '',
        }
      );
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/tools/_track.js